import { UseFormReturn } from 'react-hook-form'

import { TransactionOverview } from '../components/TransactionOverview'
import { TxOverview } from '../logic/createTxOverview'
import { TokenWithBalance } from '@/domain/common/types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'

export interface StakeViewProps {
  selectableAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  actionsViewState: ActionsViewState
  txOverview: TxOverview
}

export function StakeView({ selectableAssets, assetsFields, form, actionsViewState, txOverview }: StakeViewProps) {
  return (
    <MultiPanelDialog>
      <div className="flex flex-col gap-3">
        <DialogTitle>Stake SPK</DialogTitle>
        <div className="typography-body-3 text-secondary">
          Staking may involve some risks. Please read more{' '}
          <ExternalLink to={links.docs.stakingRisks} variant="secondary">
            here
          </ExternalLink>
          .
        </div>
      </div>
      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsFields} selectorAssets={selectableAssets} />
        <TransactionOverview txOverview={txOverview} selectedToken={assetsFields.selectedAsset} />
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
